module.exports = __webpack_public_path__ + "static/pigly05-sq-aa1da8f3cb138d1e51739051f27c66c2.png";